import DashboardLayout from "../components/layouts/DashboardLayout/DashboardLayout";

export default function PaymentsPage() {

    return (

        <DashboardLayout
            pageTitle="Finances"
        >

            <div style={{ padding: "30px" }}>

                <h1>Paiements</h1>

                <p>

                    Cette page sera développée prochainement.

                </p>

            </div>

        </DashboardLayout>

    );

}